import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RecentPostList from '../Components/RecentPostList';
import CategoryWidget from '../Components/CategoryWidget';
import TagWidget from '../Components/TagWidget';
import { GetPostByTag } from '../services/apiservice';
import { useParams } from 'react-router-dom';
import BlogItem from '../Components/BlogItem';
import Loader from '../Components/Loader';

const TagBlog = () => {
  const [blogPost, setBlogPost] = useState([]);
 const [loading, setLoading] = useState(true);
  
  const { tagpk } = useParams(); // 👈 get the slug from URL
  
  const fillBlogPost = async () => {
    try {
      const postList = await GetPostByTag(tagpk);
      const jsonPostList = JSON.parse(postList);
      setBlogPost(jsonPostList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  }

  useEffect(() => {
    fillBlogPost();
  }, []);

  return (
    <div>
      <Header />
      <div class="blog-area blog-section ptb-20">
        <div class="container-block-fluid">
          <div class="row">
            <div class="full-col col-lg-8 col-12">
              <div class="row justify-content-center">
                {
                  loading ? <Loader /> :
                    blogPost?.length == 0 ? "No Blog Post Published yet." :
                      blogPost?.map((item) => (
                        <BlogItem blogitem={item} />
                      ))
                }
              </div>
            </div>
            <div class="full-col col-lg-4 col-12">
              <div class="blog-details-right-area blog-right-sidebar">
                {/* <div class="blog-widget search-widget" data-aos="fade-up"
                  data-aos-duration="800">
                  <form class="search-form">
                    <input type="search" class="form-control" placeholder="Search..." />
                    <button type="submit">
                      <i class="bx bx-search"></i>
                    </button>
                  </form>
                </div> */}

                <div class="blog-widget recent-post-widget" data-aos="fade-up"
                  data-aos-duration="1200">
                  <RecentPostList />
                </div>

                <div class="blog-widget categories-widget" data-aos="fade-up"
                  data-aos-duration="2400">
                  <CategoryWidget />
                </div>

                <div class="blog-widget tags-widget" data-aos="fade-up"
                  data-aos-duration="2800">
                  <TagWidget />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TagBlog;